import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { Navigate } from 'react-router';
import { commonStyles } from '~/modules/covenants/CovenantsDataForm/commonStyles.ts';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import GuaranteesRootApplicationSection from '../../components/root/RootApplicationSection.tsx';
import ApplicationHeader from '../../shared/components/ApplicationHeader.tsx';
import ApplicationPageFrame from '../../shared/components/ApplicationPageFrame.tsx';
import GuaranteesApplicationStatusFlow from '../../shared/components/StatusFlow/GuaranteesApplicationStatusFlow.tsx';
import { guaranteesStepNavigationStyles } from '../../stepNavigation/styles.ts';
import ClientStepNavigator from '../stepNavigation/ClientStepNavigator.tsx';
import { useClientApplicationPage } from './useClientApplicationPage.ts';

const ClientApplicationPage: React.FC = () => {
  const {
    contragentId,
    effectiveApplicationId,
    formMethods,
    headerProps,
    isApplicationLoading,
    disabledClientStepKeys,
    modalAlert,
    modalSuccess,
    onModalClose,
    onSuccessModalClose,
    redirectPath,
    rootSectionProps,
    statusFlowProps,
  } = useClientApplicationPage();

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <ApplicationPageFrame
      modalAlert={modalAlert}
      modalSuccess={modalSuccess}
      onModalClose={onModalClose}
      onSuccessModalClose={onSuccessModalClose}
    >
      <ApplicationHeader {...headerProps} />

      {isApplicationLoading ? (
        <Box sx={commonStyles.centeredLoader}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={guaranteesClientPageStyles.applicationFlowStack}>
          <Box sx={statusFlowProps ? guaranteesClientPageStyles.applicationWithStatusSidebar : undefined}>
            {statusFlowProps && (
              <Box sx={guaranteesClientPageStyles.applicationStatusSidebarMobile}>
                <GuaranteesApplicationStatusFlow {...statusFlowProps} />
              </Box>
            )}

            <FormProvider {...formMethods}>
              <GuaranteesRootApplicationSection {...rootSectionProps} />
            </FormProvider>

            {statusFlowProps && (
              <Box sx={guaranteesClientPageStyles.applicationStatusSidebarDesktop}>
                <GuaranteesApplicationStatusFlow {...statusFlowProps} />
              </Box>
            )}
          </Box>

          <ClientStepNavigator
            applicationId={effectiveApplicationId}
            contragentId={contragentId}
            currentStepKey="step1"
            disabledStepKeys={disabledClientStepKeys}
            containerStyles={guaranteesStepNavigationStyles.compactContainer}
            stepperStyles={guaranteesStepNavigationStyles.compactStepper}
          />
        </Box>
      )}
    </ApplicationPageFrame>
  );
};

export default ClientApplicationPage;
